import { Outlet } from "react-router-dom";
import Footer from "./Footer.jsx";
import Header from "./Header.jsx";
import FlightProgress from "../ui/FlightProgress.jsx";
import ChatWidget from "../ui/ChatWidget.jsx";
import ScrollManager from "./ScrollManager.jsx";
import { useVisualEffects } from "../../hooks/useVisualEffects.js";

export default function SiteLayout() {
  useVisualEffects();

  return (
    <>
      <ScrollManager />
      <Header />
      <main><Outlet /></main>
      <ChatWidget />
      <Footer />
      <FlightProgress />
    </>
  );
}
